import { isPreloadReloadPending } from 'src/preloadErrorRecovery'

const CHUNK_LOAD_ERROR_PATTERNS = [
  // Chromium
  /Failed to fetch dynamically imported module/i,
  // Firefox
  /error loading dynamically imported module/i,
  // Safari
  /Importing a module script failed/i,
  // Vite CSS preload
  /Unable to preload CSS/i,
]

/**
 * Identifies errors caused by a lazy chunk that could not be loaded, so the
 * page-load recovery screen is shown only for them. Any error raised while an
 * automatic reload is already navigating away is treated the same way.
 */
export const isChunkLoadError = (error: unknown) => {
  if (isPreloadReloadPending()) return true
  if (!(error instanceof Error)) return false

  return (
    error.name === 'ChunkLoadError' ||
    CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(error.message))
  )
}
